import React, { useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import ContactsIcon from "@mui/icons-material/Contacts";
import { ProfileData } from "../types/profile";
import LoadingScreen from "../../../components/LoadingScreen";
import profileimgdata from "../../../../assets/Images/user-profile.png";
import ProfileAvatar from "./ProfileAvatar";
import ProfileDetailRow from "./ProfileDetailRow";
import CommonButtons from "../../../components/CommonButtons";
import { useImageUpload } from "../hooks/useImageUpload";
import { useUser } from "src/business-types/grocery/components/UserContext";

interface UserProfileProps {
  profileData: ProfileData;
  onEdit: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({ profileData, onEdit }) => {
  const [loading, setLoading] = useState(false);
  const { uploadImage } = useImageUpload();
  const { user } = useUser();

  const handleImageUpload = async (file: File) => {
    const username = user?.user_name;
    setLoading(true);
    uploadImage(file, `/pos/profile_img/${profileData._id.$oid}`, "put", `${username}.png`, `Profilelogo${username}`).then((res) => {
      window.location.reload();
    });
    setLoading(false);
  };

  return (
    <div className='w-full'>
      <div className='flex flex-col lg:flex-row items-start gap-6'>
        {/* Avatar Upload */}
        <ProfileAvatar image={String(user?.profile_image_url)} onImageChange={handleImageUpload} tooltipText='Change Photo' />
        {/* Profile Details */}
        <div className='flex-1 space-y-4'>
          <ProfileDetailRow icon={<PersonIcon />} label='Name' value={profileData.name} />
          <ProfileDetailRow icon={<CalendarMonthIcon />} label='Date of birth' value={profileData.date_of_birth} />
          <ProfileDetailRow icon={<ContactsIcon />} label='Phone Number' value={profileData.phone_number} />
          <ProfileDetailRow icon={<EmailIcon />} label='Email ID' value={profileData.email_id} />
          <ProfileDetailRow icon={<HomeIcon />} label='Address' value={profileData.address_line_1} />
          <CommonButtons label='Edit Profile' onClick={onEdit} />
        </div>
      </div>
      {loading && <LoadingScreen />}
    </div>
  );
};

export default UserProfile;
